import { isVoucherHidden } from 'lib/voucher/isVoucherHidden'

export const EXPIRING_VOUCHER_WINDOW_MS = 48 * 60 * 60 * 1000

/**
 * A null `voucherDisplayAmount` means svc-promo could not express a single amount
 * (percentage rewards), not that nothing is left, so only a known zero balance is excluded.
 */
function hasRemainingValue(voucher: App.PublicVoucher): boolean {
  return voucher.voucherDisplayAmount === null || voucher.voucherDisplayAmount > 0
}

/**
 * Picks the voucher to remind the customer about before it expires (GR-5151).
 *
 * Expects the `status: 'active'` my-vouchers list, which already leaves out cancelled,
 * voided and expired vouchers. A voucher qualifies when it is visible, unredeemed, still
 * has value and expires within the next 48 hours. Of those, the one expiring first wins,
 * with voucherId breaking ties so the same customer always sees the same voucher.
 */
export function pickExpiringVoucher(
  vouchers: ReadonlyArray<App.PublicVoucher>,
  now: number,
): App.PublicVoucher | undefined {
  const windowEnd = now + EXPIRING_VOUCHER_WINDOW_MS

  return vouchers
    .map(voucher => ({ voucher, expiresAtMs: Date.parse(voucher.expiresAt) }))
    .filter(({ voucher, expiresAtMs }) =>
      expiresAtMs > now &&
      expiresAtMs <= windowEnd &&
      !voucher.usedAt &&
      !isVoucherHidden(voucher) &&
      hasRemainingValue(voucher),
    )
    .sort((a, b) => a.expiresAtMs - b.expiresAtMs || (a.voucher.voucherId < b.voucher.voucherId ? -1 : 1))
    .at(0)?.voucher
}
